import { createTheme } from '@mui/material/styles'

// Types
import type { Direction } from '@mui/material/styles'

// Fonts
import TlichoFont from '@/styles/fonts/tlicho'

const ThemeConfig = (dir: Direction) =>
	createTheme({
		direction: dir,
		cssVariables: { colorSchemeSelector: 'class' },
		palette: {
			primary: { light: '#d40000', main: '#8b0000', dark: '#470010', contrastText: '#fff' },
			secondary: { light: '#d79058', main: '#824d3b', dark: '#6a421e', contrastText: '#fff' }
		},
		shape: { borderRadius: 8 },
		typography: {
			fontFamily: TlichoFont.style.fontFamily,
			fontSize: 14,
			button: {
				fontWeight: 700,
				textTransform: 'inherit'
			}
		},
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					body: { scrollBehavior: 'smooth' },
					a: { textDecoration: 'none' }
				}
			},
			MuiButton: {
				defaultProps: {
					variant: 'contained',
					disableElevation: true
				}
			}
		}
	})

export default ThemeConfig
